export const TARGETS = [
  { code: "fr", label: "Français 🇫🇷" },
  { code: "en", label: "English 🇬🇧" },
  { code: "es", label: "Español 🇪🇸" },
  { code: "ar", label: "العربية" },
  { code: "tr", label: "Türkçe 🇹🇷" },
  { code: "pt", label: "Português 🇵🇹" },
];
